var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_2",on:{"click":function($event){return _vm.handleClickInternal()}}},[_c('h1',[_vm._v(_vm._s(_vm.msg)+" "+_vm._s(_vm.numClicks))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.docs)?_c('router-link',{attrs:{"to":'/docs/' + this.docs[1] + '/' + this.docs[2] + '/' + this.docs[3]}},[_vm._v(_vm._s(this.docs[3]))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7460c4de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component2.vue
// module id = null
// module chunks = 